import { useContext } from 'react';
import { SettingsContext } from '@utility/contexts/SettingsContext';

// ----------------------------------------------------------------------

const useSettings = () => useContext(SettingsContext);

export default useSettings;
